<template>
    <ThePage>
        <div class="d-flex justify-content-between mb-3">
            <div class="font-weight-bold">Экспорт текущих биллингуемых устройств</div>
        </div>
        <div class="card mb-4">
            <div class="card-body">
                <div class="mb-4">
                    Будет выгружена наработка по компаниям за период:<br>
                    <strong>{{ format(since, 'DD.MM.YYYY') }} — {{ format(until, 'DD.MM.YYYY') }}</strong>
                </div>

                <div>
                    <small>Выгрузить:</small>
                    <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('csv')">CSV</button>
                    <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('xlsx')"><i class="tlm-icon-excel mr-2" /> Excel</button>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between mb-3">
            <div class="font-weight-bold">Ежемесячный отчет по использованию ЛК.</div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    Будет выгружена сумма денежных средств, количество устройств онлайн, партнерские вознаграждения:<br>
                </div>

                <div>
                    <small>Выгрузить:</small>
                    <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('csv', true)">CSV</button>
                    <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('xlsx', true)">
                        <i
                            class="tlm-icon-excel mr-2" /> Excel
                    </button>
                </div>
            </div>
        </div>
    </ThePage>
</template>

<script>
import axios from 'axios'
import FileSaver from 'file-saver'
import { startOfMonth, format } from 'date-fns'

import ThePage from '@/components/ThePage'

export default {
    components: {
        ThePage
    },

    data() {
        const now = new Date()

        return {
            since: format(startOfMonth(now), 'YYYY-MM-DD'),
            until: format(now, 'YYYY-MM-DD')
        }
    },

    methods: {
        format(date, f = 'YYYY-MM-DD') {
            return format(date, f)
        },

        async getFile(format, monthly = false) {
            let response = null
            if (monthly) {
                response = await axios.get('api/admin/billing-monthly', {
                    responseType: 'blob',
                    params: { export: format, ...this.filter }
                })
            } else {
                response = await axios.get('api/admin/billing-slice', {
                    responseType: 'blob',
                    params: { export: format, ...this.filter }
                })
            }

            if (!response.data.size) {
                return
            }

            let blob = new Blob([response.data], { type: format === 'xlsx' ? 'application/vnd.ms-excel' : 'text/csv' })

            if (monthly) {
                FileSaver.saveAs(blob, `Ежемесячный отчет.${format}`)
            } else {
                FileSaver.saveAs(blob, `Наработка по компаниям ${this.since} - ${this.until}.${format}`)
            }
        }
    }
}
</script>
